import ActionButton from '../action-button';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import { useTranslations } from '@/i18n/use-translations';
import { useFlowMode } from '../../../use-flow-mode';
import { isOrganizeMode } from '@/components/events/helpers/mode.helper';

export default function AddSession({
  duration,
  onShowForm,
  formDuration,
}: {
  duration?: number;
  onShowForm?: () => void;
  formDuration?: number;
}) {
  const t = useTranslations();
  const mode = useFlowMode();

  // Hide button if form duration >= gap duration
  const shouldHideButton = formDuration !== undefined && duration !== undefined && formDuration >= duration;

  if (shouldHideButton) {
    return null;
  }

  return (
    <ActionButton
      icon={<AddOutlinedIcon />}
      onClick={onShowForm}
      disabled={isOrganizeMode(mode)}
      label={t('common.new')}
      dataTestId="add-wizard-button"
    />
  );
}
